<template lang="pug">
  div
    informacoes-analise(
      :responsavel="cadastro.usuario.pessoa.nomeRazaoSocial"
      :data="cadastro.dataFinalizacao",
      :cargo="cadastro.perfil.nome"
      v-if="showInformacoesAnalise"
    )

    divider(v-if="!isRetificacao", label="Peças Técnicas")
    div.mt-1
      appMapa(
        v-if="!isRetificacao"
        ref="mapa"
        idMapa="mapaArrecadacaoGeo",
        height="65vh",
        :mapLayersConfigs="layers"
        :buttons="buttonsConfig"
        :featureLayerConfig="featureLayerConfig"
      )
    div.mt-1
      informacoes-area-arrecadacao(
        v-if="!isRetificacao"
        :area="area"
        :perimetro="perimetro"
        :municipios="municipios"
      )

      div(v-if="documentosAutenticavel")
        app-visualizar-documentos(
          :dadosCadastros="getDocumentosAutenticaveis()"
        )
      div(v-if="documentosCadastro")
        app-visualizar-documentos(
          :dadosCadastros="getDocumentos()"
          @setValidacaoDocumentos="setValidacaoDocumentos",
        )
</template>

<script>
import AppMapa from '@/components/AppMapa'
import InformacoesAreaArrecadacao from '@/screens/arrecadacao/components/InformacoesAreaArrecadacao'
import Divider from '@/screens/arrecadacao/components/Divider'
import AppLabel from '@/components/AppLabel'
import InformacoesAnalise from '@/screens/arrecadacao/components/InformacoesAnalise'
import { mapActions } from 'vuex'
import FileHelper from '@/utils/fileHelper'
import Utils from '@/utils/utils'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import layerStyles from '@/utils/layerStyles'
import AppVisualizarDocumentos from '../../../components/AppVisualizarDocumentos.vue'

export default {
  components: {
    AppMapa,
    InformacoesAreaArrecadacao,
    Divider,
    AppLabel,
    InformacoesAnalise,
    AppDownloadArquivo,
    AppVisualizarDocumentos
  },

  props: {
    cadastro: {
      required: true,
      type: Object
    },
    showInformacoesAnalise: {
      type: Boolean,
      required: false,
      default: true
    },
    isRetificacao: {
      default: false
    }
  },

  data () {
    return {
      buttonsConfig: [
        {
          id: 'centralizar',
          icon: 'fa-crosshairs',
          tooltip: 'Centralizar',
          onClick: this.centerMap
        }
      ],

      tabelaArquivos: [
        {
          nome: 'Memorial Descritivo',
          campo: 'documentoMemorialDescritivo',
          nomeArquivo: 'memorial_descritivo.pdf'
        },
        {
          nome: 'Planta',
          campo: 'planta',
          nomeArquivo: 'planta.pdf'
        },
        {
          nome: 'Cálculo Análitico',
          campo: 'calculoAnalitico',
          nomeArquivo: 'calculo_analitico.pdf'
        },
        {
          nome: 'Mapa de Localização',
          campo: 'mapaLocalizacao',
          nomeArquivo: 'mapa_localizacao.pdf'
        },
        {
          nome: 'Leitura do mapa',
          campo: 'leituraMapa',
          nomeArquivo: 'leitura_mapa.pdf'
        }
      ],

      featureLayerConfig: {
        url: process.env.URL_MAPSERVER_MUNICIPIOS,
        style: layerStyles.ESTADO,
        popup: (layer) => `${layer.feature.properties.NM_MUNICIP}`
      }
    }
  },
  computed: {
    area () {
      const json = JSON.parse(this.cadastro?.pecaTecnica?.dadoPecaTecnica?.jsonPlanilha ? this.cadastro?.pecaTecnica?.dadoPecaTecnica?.jsonPlanilha : null)
      if (json) {
        return this.format(json?.identificacaoPlanilha?.areaTotal, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
      }
      return this.format(this.cadastro?.pecaTecnica?.area, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    },

    perimetro () {
      const json = JSON.parse(this.cadastro?.pecaTecnica?.dadoPecaTecnica?.jsonPlanilha ? this.cadastro?.pecaTecnica?.dadoPecaTecnica?.jsonPlanilha : null)
      if (json) {
        return this.format(json?.identificacaoPlanilha?.perimetroTotal, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
      }
      return this.format(this.cadastro?.pecaTecnica?.perimetro)
    },

    municipios () {
      return this.cadastro?.pecaTecnica?.municipios
    },

    layers () {
      const geom = typeof this.cadastro?.pecaTecnica.geom === 'string'
        ? JSON.parse(this.cadastro?.pecaTecnica.geom)
        : this.cadastro?.pecaTecnica.geom

      if (geom) return [{ geoJson: geom }]

      return []
    },

    memorialDescritivo () {
      return this.cadastro?.pecaTecnica?.memorialDescritivo
    },

    documentosAutenticavel () {
      return this.cadastro?.pecaTecnica?.dadoPecaTecnica?.documentosAutenticavel
    },
    documentosCadastro () {
      return this.cadastro?.pecaTecnica?.dadoPecaTecnica?.documentos
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'documentoArrecadacao/download'
    }),

    setValidacaoDocumentosAutenticaveis (dadosCadastro) {
      let i = 0
      this.getDocumentosAutenticaveis().map((dados, index) => {
        if (dados.tipo === dadosCadastro.tipo) {
          i = index
        }
      })
      this.getDocumentosAutenticaveis()[i] = dadosCadastro
    },

    setValidacaoDocumentos (dadosCadastro) {
      let i = 0
      this.getDocumentos().map((dados, index) => {
        if (dados.tipo === dadosCadastro.tipo) {
          i = index
        }
      })
      this.getDocumentos()[i] = dadosCadastro
    },

    format: Utils.format,

    centerMap () {
      this.$refs.mapa.refreshMap()
    },

    async download (arquivo) {
      const documento = this.cadastro?.pecaTecnica[arquivo.campo]

      const arrayBuffer = await this.downloadDocumentos({ fileKey: documento.fileKey, id: documento.id })

      FileHelper.saveFile(arrayBuffer, arquivo.nomeArquivo)
    },
    getDocumentosAutenticaveis () {
      const headers = [{ propriedade: 'tipoDocumentoAutenticavel.descricao', titulo: 'Tipo de documento' }, { propriedade: 'nomeDocumento', titulo: 'Nome do arquivo' }, { propriedade: 'visualizar', titulo: '' }]
      const dados = {
        label: 'Documentos Autenticáveis',
        tipo: 'tabelaComCheck',
        headers: headers,
        data: this.documentosAutenticavel
      }
      return [dados]
    },
    getDocumentos () {
      const headers = [{ propriedade: 'tipoDocumento.nome', titulo: 'Tipo de documento' }, { propriedade: 'nomeOriginal', titulo: 'Nome do arquivo' }, { propriedade: 'visualizar', titulo: '' }]
      const dados = {
        label: 'Documentos',
        tipo: 'tabelaComCheck',
        headers: headers,
        data: this.documentosCadastro
      }
      return [dados]
    }
  }
}
</script>

<style lang="scss" scoped>
.arquivos {
  margin-top: 2rem;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/VisualizarCadastroColetivo.vue